import axios from 'axios';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useRedirectOnChange } from '../../hooks/redirectOnChange';
import { useLocationState } from '../../hooks/useLocationState';
import { getOryLoginStatusSelector } from '../../modules/auth/selectors';
import { OryApiRequestCancelTokenId } from '../../ory/config/const';
import { useOryLoginApi } from '../../ory/hooks/oryApi';
import { useAppContext } from '../App/AppContextProvider';
import { logoutAndNavigate } from './logout';

export interface ILogoutLocationStateRedirect {
  redirectTo: string;
}

export function LogoutPage(): JSX.Element {
  const { loggedIn } = useAppContext();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const oryLoginStatus = useSelector(getOryLoginStatusSelector);
  const { logoutFromOry } = useOryLoginApi();
  const { getLocationState } = useLocationState<ILogoutLocationStateRedirect>();

  useRedirectOnChange();

  useEffect(() => {
    const cancelTokenSource = axios.CancelToken.source();

    const logout = async () => {
      const navigatePathAfterLogout = getLocationState()?.redirectTo;

      await logoutAndNavigate({
        cancelTokenSource,
        dispatch,
        logoutFromOry,
        navigate,
        navigatePathAfterLogout,
        oryLoginStatus,
      });
    };

    logout();

    return () => {
      cancelTokenSource.cancel(OryApiRequestCancelTokenId);
    };
  }, [loggedIn]);

  return <>{false}</>;
}
